<script setup>
  import {OverlayCard} from 'digitalpower';

  const casas = [
    {
      img: '/images/casa01.jpg',
      text: `Lau, Juan y Pedro
      PH de 56m²
      `
    },
    {
      img: '/images/casa02.jpg',
      text: `Nacho
      Departamento de 40m²
      `
    },
    {
      img: '/images/casa03.png',
      text: `Adrián
      Piso de 80m²
      `
    },
    {
      img: '/images/casa04.jpg',
      text: `Romi, Mario y Helena
      Departamento de 36m²
      `
    },
    {
      img: '/images/casa05.jpg',
      text: `Julia
      PH de 45m²
      `
    },
    {
      img: '/images/casa06.jpg',
      text: `Laura, Pablo y Bruno
      Departamento de 65m²
      `
    },
  ]
</script>

<template>
  <section flex flex-center flex-column gapped radius-border>
    <h1 class="mb-4">Conocé nuestra obra</h1>
    <div class="casas" flex flex-center flex-wrap gapped>
      <OverlayCard noselect v-for="(casa, key) in casas" :key class="casa" :img="casa?.img" :text="casa?.text"></OverlayCard>
    </div>
  </section>
</template>

<style scoped lang="scss">
section {
  height: unset;
  min-height: unset;
  position: relative;

  width: 90%;
  margin: auto;
  padding: 4em;

  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(20px);

  margin-top: -20em;
}

.casas {
}

.casa {
  max-width: 300px !important;
  width: 100% !important;
  height: 250px !important;
}

@media screen and (max-width: 600px) {
  section {
    padding: 2em;
  }
}
</style>

<style>
.casa {
  p {
    white-space: pre-line;
  }
}
</style>